document.querySelectorAll('.bulk-add-to-cart_button').forEach((form) => {
  form.addEventListener('submit', function(event) {
    event.preventDefault();
    console.log('click on add to cart');
    document.getElementById('add_tocart_sticky_button').click();
    const addToCartButtons  = document.querySelectorAll('.add_tocart_custom_button');
    setTimeout(() => {
      addToCartButtons.forEach((button) => {
        button.removeAttribute('aria-busy');
      });
    }, 1500);
    
  });
})